module.exports = __webpack_public_path__ + "img/how-to-get-unsplash-photo-id.b32b0d08.gif";